/**
 * Hiérarchie panel staff (auth_role.id — 18 rôles, migration _006).
 *
 * Direction  : 1 Founder · 2 Team Director · 3 Director of Administration · 4 Director of Moderation
 * Admins     : 5 Master Administrator · 6 Senior Administrator · 7 Administrator
 * Modos      : 8 Master Moderator · 9 Senior Moderator · 10 Moderator · 11 Junior Moderator
 * Équipe     : 12 Community Manager · 13 Support · 14 Team Member · 15 Team Advisor (ex-GR) · 16 Alpha Tester
 * Hors panel : 17 Créateur de contenu (scénariste) · 18 Joueurs
 *
 * Accès panel = ensemble NON contigu : Direction + admins + modos (1–11), Team Member (14),
 * Team Advisor (15). SANS accès panel : Community Manager (12) et Support (13) — rôles Discord,
 * gérés hors panel —, Alpha Tester (16, bêta-testeurs), Créateur (17), Joueurs (18).
 *
 * Validation « actif » d'un scénario : référent scénario (auth_referent), pas le créateur du brouillon.
 */

/** Membre équipe autorisé à ENTRER dans le panel (ensemble non contigu). */
export function isPanelTeamMember(roleId: number): boolean {
  return (roleId >= 1 && roleId <= 11) || roleId === 14 || roleId === 15;
}

/** Équipe scénarios CTA — identique à l'équipe panel. */
export function isScenarioTeamRole(roleId: number): boolean {
  return isPanelTeamMember(roleId);
}

/** Rôle « Team Advisor » (15, ex-GR — Groupe de réflexion) : pilote les scénarios / référent. */
export function isGrRole(roleId: number): boolean {
  return roleId === 15;
}

/** Founder uniquement (ex-CM). */
export function canPanelCm(roleId: number): boolean {
  return roleId === 1;
}

/** Palier admin : Direction + administrateurs (rôles 1 à 7). */
export function canPanelAdminTier(roleId: number): boolean {
  return roleId >= 1 && roleId <= 7;
}

/** Salon modo : Direction (1–4), administrateurs (5–7) et modérateurs (8–11). */
export function canPanelModoTier(roleId: number): boolean {
  return roleId >= 1 && roleId <= 11;
}

/** Espace scénariste : toute l'équipe panel (Direction, admins, modos, Team Member, Team Advisor). */
export function canPanelScenariste(roleId: number): boolean {
  return isPanelTeamMember(roleId);
}

/** Modération, signalements, fiches joueurs (surveillance) — Direction + admins + modos (rôles 1 à 11). */
export function canPanelModeratePlayers(roleId: number): boolean {
  return roleId >= 1 && roleId <= 11;
}

/** Premium, économie, possessions avancées — palier admin. */
export function canPanelManagePremium(roleId: number): boolean {
  return canPanelAdminTier(roleId);
}

/** CTA, création / gestion scénarios, catégories mission — équipe panel scénarios. */
export function canPanelManageInterventions(roleId: number): boolean {
  return isScenarioTeamRole(roleId);
}

export function canPanelViewInterventionsCta(roleId: number): boolean {
  return canPanelManageInterventions(roleId);
}

/** Config, maintenance, sauvegardes, rôles individuels — Founder uniquement. */
export function canPanelSystemCm(roleId: number): boolean {
  return roleId === 1;
}
